import { setCache, clearCache, currentLang } from '@/helpers';
import { grantAccessToken, signOutUser } from '@services/auth/authDataService';
import authStoreActions from '@constans/store/auth/authStoreActions';
import authStoreMutations from '@constans/store/auth/authStoreMutations';
import userStoreActions from '@constans/store/user/userStoreActions';
import userStoreMutations from '@constans/store/user/userStoreMutations';
import estateStoreMutations from '@/internal/constans/store/estate/estateStoreMutations';
const actions = {
    async [authStoreActions.LOGIN]({ commit, dispatch }, payload) {
        await grantAccessToken(payload).then(response => {
            if ('access_token' in response) {
                // Save to cache
                setCache(response);
                // Save to state
                commit(authStoreMutations.SET_AUTH, response);
                // Ask for user
                dispatch(`user/${userStoreActions.GET_USER}`, null, { root: true });
            }
        }).catch(err => {
            if (err.status === 'Error') {
                commit(authStoreMutations.SET_LOGIN_ERR_MSG, currentLang === 'sv' ? 'Felaktiga inloggningsuppgifter' : 'Wrong credentials');
            }
        });
    },
    async [authStoreActions.LOGOUT]({ commit }) {
        await signOutUser().then(() => {
            commit(authStoreMutations.CLEAR_AUTH);
            commit(`user/${userStoreMutations.CLEAR_USER}`, null, { root: true });
            commit(`estate/${estateStoreMutations.RESET_STATE}`, null, { root: true });
            clearCache();
        });
    }
};
export default actions;
